var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMentorAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 39.6875,
    fill: "#E9ECEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4109_13662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8332 56.6678L30.4465 26.3387L24.2357 19.9345L21.1665 23.0037L27.9332 29.7703V29.7945C26.6765 32.187 25.9998 35.0145 25.9998 38.0595V50.1428L21.1665 54.9762V57.3928H54.3473L59.1807 62.2262L62.2498 59.157L59.8332 56.6678ZM40.4998 64.667C43.1823 64.667 45.3332 62.5162 45.3332 59.8337H35.6665C35.6665 62.5162 37.8173 64.667 40.4998 64.667ZM54.9998 46.977V38.0837C54.9998 30.6403 51.0365 24.4537 44.1248 22.8103V21.167C44.1248 19.1612 42.5057 17.542 40.4998 17.542C38.494 17.542 36.8748 19.1612 36.8748 21.167V22.8103C36.5123 22.8828 36.174 23.0037 35.8598 23.1003C35.6182 23.1728 35.3765 23.2695 35.1348 23.3662H35.1107C35.0865 23.3662 35.0865 23.3662 35.0623 23.3903C34.5065 23.6078 33.9507 23.8737 33.419 24.1395C33.419 24.1395 33.3948 24.1395 33.3948 24.1637L54.9998 46.977Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4109_13662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMentorAssigned);
export default __webpack_public_path__ + "static/media/EmptyMentorAssigned.30c6da496a6ad207bad3c4b2f080f4bf.svg";
export { ForwardRef as ReactComponent };